export default __webpack_public_path__ + "static/media/logo-white.2a0fdd9d.png";